var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowTips)?_c('div',{staticClass:"tab-tips"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.tipsContent))]),_c('i',{staticClass:"wphk-ui-icon icon-delete",on:{"click":_vm.handleClickCloseTip}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }